<template>
  <!-- Kontener pojedynczego filtra: flexowy układ w wierszu -->
  <div class="filter d-flex">
    <!-- Etykieta filtra: wyświetla przekazaną nazwę bez tłumaczenia -->
    <div class="name">{{ name }}</div>
    <!-- Symbol operatora (np. '=', '>='), wyświetlany jeśli został przekazany jako props -->
    <span class="symbol">{{ symbol }}</span>
    <!-- Pole input wiązane dwukierunkowo z wartością filtra:
         - name odpowiada kluczowi w store.filters
         - v-model.lazy aktualizuje value po zdarzeniu 'change'
    -->
    <input
      :name="fieldName"
      v-model.lazy="value"
    />
  </div>
</template>

<script>
import { watch, ref } from "vue";                                  // Importujemy ref do reaktywnej zmiennej i watch do obserwacji zmian
import { useCurrentFiltersStore } from "../../stores/currentFilters"; // Import store Pinia z aktualnymi filtrami
import { isNOSG } from "@/config/appVersion";

export default {
  name: "SingleFilter",    // Unikalna nazwa komponentu Vue
  props: ["name", "symbol", "fieldName"], // Definicja oczekiwanych właściwości

  setup(props) {
    // Pobranie instancji store z filtrami
    const filtersStore = useCurrentFiltersStore();

    if (
      props.fieldName === "similarity" &&
      isNOSG &&
      (filtersStore.filters[props.fieldName] === undefined || filtersStore.filters[props.fieldName] === "")
    ) {
      filtersStore.addItem(props.fieldName, 1);
    }

    // Inicjalizacja wartości filtra z store lub pustego stringa
    const value = ref(
      filtersStore.filters[props.fieldName] ?? ""
    );

    /**
     * Funkcja zapisuje nową wartość filtra do store
     * @param {string} text - wprowadzona wartość
     */
    const saveValue = (text) => {
      filtersStore.addItem(props.fieldName, text);
    };

    // Obserwujemy zmiany value i zapisujemy do store przy każdej zmianie
    watch(value, (newValue) => {
      saveValue(newValue);
    });

    // Zwracamy zmienną i store do użycia w template
    return { value, filtersStore };
  },
};
</script>

<style scoped>
/* Styl całego kontenera filtra: dolna granica i padding */
.filter {
  border-bottom: 1px solid #b7b7b5;
  padding-bottom: 5px;
}

/* Styl symbolu operatora: padding i stała szerokość */
.symbol {
  padding: 5px 9px 5px 8px; /* padding: góra, prawo, dół, lewo */
  width: 24px;
  margin-right: 1px;
}

/* Styl pola input: szerokość, padding, wyśrodkowanie tekstu i uppercase */
input {
  width: 124px;
  padding: 2px 10px;
  text-align: center;
  text-transform: uppercase;
}
</style>
